import { Grid } from "@mui/material";
import Box from "@mui/material/Box";

import { LOGIN_SECTION_ID } from "../../constants";
import { IBreakPointProps } from "../../models";
// styles
import styles from "./styles.module.scss";

export const BreakPoint = (props: IBreakPointProps) => {
  return (
    <div className={styles.break_point_container}>
      <div className={styles.right_container}>{props.leftElement}</div>
      <div className={styles.left_container}>{props.rightElement}</div>
    </div>
  );
};
